export const messages = {
  en: {
    templateDesigner: {
      title: 'Receipt Template Designer',
      step1: 'Basic Settings',
      step2: 'Data Binding',
      step3: 'Stamp Settings',
      saveTemplate: 'Save Template',
      preview: 'Preview',
      actualSize: 'Actual Size'
    },
    feePrintPageManage: {
      search: {
        title: 'Search Conditions',
        pageId: 'Receipt ID',
        pageName: 'Name',
        state: 'Status',
        all: 'All',
        enabled: 'Enabled',
        disabled: 'Disabled'
      },
      list: {
        title: 'Receipt Template'
      },
      table: {
        pageId: 'Receipt ID',
        pageName: 'Name',
        communityId: 'Community ID',
        templateName: 'Receipt Page',
        state: 'Status',
        enabled: 'Enabled',
        disabled: 'Disabled',
        operation: 'Operation'
      },
      add: {
        title: 'Add Receipt Template',
        pageName: 'Name',
        pageNamePlaceholder: 'Please enter name',
        template: 'Receipt Page',
        templatePlaceholder: 'Please select receipt page',
        success: 'Add successfully',
        customDesign: 'Custom Design',
        designTip: 'Use visual designer to create custom receipt templates'
      },
      edit: {
        title: 'Edit Receipt Template',
        pageName: 'Name',
        pageNamePlaceholder: 'Please enter name',
        template: 'Receipt Page',
        templatePlaceholder: 'Please select receipt page',
        success: 'Update successfully'
      },
      delete: {
        title: 'Delete Confirmation',
        confirmText: 'Are you sure to delete this receipt template?',
        success: 'Delete successfully'
      },
      validate: {
        pageNameRequired: 'Name is required',
        pageNameMaxLength: 'Name cannot exceed 128 characters',
        templateRequired: 'Receipt page is required',
        pageIdRequired: 'Receipt ID is required'
      },
      fetchError: 'Failed to fetch data'
    }
  },
  zh: {
    templateDesigner: {
      title: '收据模板设计器',
      step1: '基础设置',
      step2: '数据绑定',
      step3: '印章设置',
      saveTemplate: '保存模板',
      preview: '预览',
      actualSize: '实际尺寸'
    },
    feePrintPageManage: {
      search: {
        title: '查询条件',
        pageId: '收据ID',
        pageName: '名称',
        state: '状态',
        all: '全部',
        enabled: '启用',
        disabled: '停用'
      },
      list: {
        title: '收据模板'
      },
      table: {
        pageId: '收据ID',
        pageName: '名称',
        communityId: '小区ID',
        templateName: '收据页面',
        state: '状态',
        enabled: '启用',
        disabled: '停用',
        operation: '操作'
      },
      add: {
        title: '添加收据模板',
        pageName: '名称',
        pageNamePlaceholder: '请输入名称',
        template: '收据页面',
        templatePlaceholder: '请选择收据页面',
        success: '添加成功',
        customDesign: '自定义设计',
        designTip: '使用可视化设计器创建自定义收据模板'
      },
      edit: {
        title: '修改收据模板',
        pageName: '名称',
        pageNamePlaceholder: '请输入名称',
        template: '收据页面',
        templatePlaceholder: '请选择收据页面',
        success: '修改成功'
      },
      delete: {
        title: '删除确认',
        confirmText: '确定删除该收据模板吗？',
        success: '删除成功'
      },
      validate: {
        pageNameRequired: '名称不能为空',
        pageNameMaxLength: '名称不能超过128个字符',
        templateRequired: '收据页面不能为空',
        pageIdRequired: '收据ID不能为空'
      },
      fetchError: '获取数据失败'
    }
  }
}
